import {useState, useEffect, useRef} from "react";
import SalesforceFieldError from "./SalesforceFieldError";
const { normalizeExchangeValue, exchangeFieldError } = require("../shared/exchangeValidation");
const { exchangeError, exchangeDateError } = require("../shared/exchangeEnglish");
const { buildQuestionLookup, isQuestionVisible } = require("../shared/progress");

const NOMBRE_DE_PARTS_ID_FORM = "00NaT000001fa0X";

const ESTIMATION_TEST_OPTIONS = {
  "Licence 1": [
    "ANGLAIS (LLCER)",
    "DROIT",
    "ECONOMIE-GESTION",
    "ESPAGNOL (LLCER)",
    "HISTOIRE",
    "LETTRES",
    "MATHEMATIQUES",
    "PHYSIQUE",
    "PHYSIQUE-CHIMIE",
    "PHYSIQUE-CHIMIE-PARCOURS D’INGENIEUR ECAM RENNES",
    "SCIENCE POLITIQUE",
    "SCIENCE POLITIQUE - PARCOURS EUROPEAN SCHOOL OF GOVERNMENT (ESG)",
    "SCIENCES DE LA VIE",
    "SCIENCES POUR LA SANTE",
    "DOUBLE LICENCE DROIT- ECONOMIE ET GESTION",
    "DOUBLE LICENCE DROIT-HISTOIRE",
    "Double licence Droit-Lettres",
    "DOUBLE LICENCE DROIT- SCIENCE POLITIQUE",
    "DOUBLE LICENCE HISTOIRE-LETTRES",
    "DOUBLE LICENCE HISTOIRE-SCIENCE POLITIQUE",
    "DOUBLE LICENCE SCIENCE POLITIQUE-ANGLAIS",
    "DOUBLE LICENCE SCIENCE POLITIQUE-ESPAGNOL",
    "DOUBLE LICENCE SCIENCE POLITIQUE - LETTRES",
    "DOUBLE CURSUS DROIT-PHILOSOPHIE",
    "DOUBLE CURSUS MASTERS ET MANAGEMENT",
    "DOUBLE CURSUS SCIENCE POLITIQUE-PHILOSOPHIE"
  ],
  "Licence 2": [
    "ANGLAIS (LLCER)",
    "DROIT",
    "ECONOMIE-GESTION",
    "ESPAGNOL (LLCER)",
    "HISTOIRE",
    "LETTRES",
    "MATHEMATIQUES",
    "PHYSIQUE",
    "PHYSIQUE-CHIMIE",
    "PHYSIQUE-CHIMIE-PARCOURS D’INGENIEUR ECAM RENNES",
    "SCIENCE POLITIQUE",
    "SCIENCE POLITIQUE - PARCOURS EUROPEAN SCHOOL OF GOVERNMENT (ESG)",
    "SCIENCES DE LA VIE",
    "SCIENCES POUR LA SANTE",
    "DOUBLE LICENCE DROIT- ECONOMIE ET GESTION",
    "DOUBLE LICENCE DROIT-HISTOIRE",
    "Double licence Droit-Lettres",
    "DOUBLE LICENCE DROIT- SCIENCE POLITIQUE",
    "DOUBLE LICENCE HISTOIRE-LETTRES",
    "DOUBLE LICENCE HISTOIRE-SCIENCE POLITIQUE",
    "DOUBLE LICENCE SCIENCE POLITIQUE-ANGLAIS",
    "DOUBLE LICENCE SCIENCE POLITIQUE-ESPAGNOL",
    "DOUBLE LICENCE SCIENCE POLITIQUE - LETTRES",
    "DOUBLE CURSUS DROIT-PHILOSOPHIE",
    "DOUBLE CURSUS MASTERS ET MANAGEMENT",
    "DOUBLE CURSUS SCIENCE POLITIQUE-PHILOSOPHIE"
  ],
  "Licence 3": [
    "ANGLAIS (LLCER)",
    "DROIT",
    "ECONOMIE-GESTION",
    "ESPAGNOL (LLCER)",
    "HISTOIRE",
    "LETTRES",
    "MATHEMATIQUES",
    "PHYSIQUE-CHIMIE",
    "PHYSIQUE-CHIMIE-PARCOURS D’INGENIEUR ECAM RENNES",
    "SCIENCE POLITIQUE",
    "SCIENCE POLITIQUE - PARCOURS EUROPEAN SCHOOL OF GOVERNMENT (ESG)",
    "SCIENCES DE LA VIE",
    "SCIENCES POUR LA SANTE",
    "DOUBLE LICENCE DROIT- ECONOMIE ET GESTION",
    "DOUBLE LICENCE DROIT-HISTOIRE",
    "Double licence Droit-Lettres",
    "DOUBLE LICENCE DROIT- SCIENCE POLITIQUE",
    "DOUBLE LICENCE HISTOIRE-LETTRES",
    "DOUBLE LICENCE HISTOIRE-SCIENCE POLITIQUE",
    "DOUBLE LICENCE SCIENCE POLITIQUE-ANGLAIS",
    "DOUBLE LICENCE SCIENCE POLITIQUE-ESPAGNOL",
    "DOUBLE LICENCE SCIENCE POLITIQUE - LETTRES",
    "DOUBLE CURSUS DROIT-PHILOSOPHIE",
    "DOUBLE CURSUS MASTERS ET MANAGEMENT",
    "DOUBLE CURSUS SCIENCE POLITIQUE-PHILOSOPHIE",
    "LICENCE PRO GUIDE-CONFÉRENCIER & MÉDIATEUR DES PATRIMOINES",
    "LICENCE PRO NOTARIAT",
    "PRÉPA DCG"
  ]
};

export default function QuestionText({ questionInfo, updateQuestionValue , sousCritereIndex, questionIndex , getNumberFiliereActif , getNumberCritereActif , data , filiere, estimationTestSelection, setEstimationTestSelection, isEstimationTestWindowOpen}) {

    /* ------------------------------------------------------------ STATE ------------------------------------------------------------ */

    const normalizeCVEC = (cvecRaw) => {
      return String(cvecRaw || "")
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, "");
    };

    const normalizeINE = (ineRaw) => {
      return String(ineRaw || "")
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, "");
    };

    const normalizeNIR = (nirRaw) => {
      return String(nirRaw || "")
        .replace(/\D/g, "");
    };

    const normalizeNombreDeParts = (rawValue) => {
      const normalizedSeparators = String(rawValue || "")
        .replace(/,/g, ".")
        .replace(/[^\d.]/g, "");
      const [integerPart, ...decimalParts] = normalizedSeparators.split(".");

      return decimalParts.length > 0
        ? integerPart + "." + decimalParts.join("")
        : integerPart;
    };

    const sanitizeValue = (rawValue, placeholder, idForm) => {
      if (idForm === NOMBRE_DE_PARTS_ID_FORM) return normalizeNombreDeParts(rawValue);
      if (placeholder === 3) return normalizeCVEC(rawValue).slice(0, 12);
      if (placeholder === 4) return normalizeINE(rawValue).slice(0, 12);
      if (placeholder === 7) return normalizeNIR(rawValue).slice(0, 15);
      return rawValue;
    };

    const [value, setValue] = useState(() => sanitizeValue(
      questionInfo.value,
      questionInfo.placeholder,
      questionInfo.idForm
    ));
    const [error, setError] = useState(""); // ⬅️ nouveau

    const inputRef = useRef(null);

    const currentPeriod = data?.data?.[getNumberFiliereActif];
    const questionLookup = buildQuestionLookup(currentPeriod);
    let visible = isQuestionVisible(questionInfo, {
      dataFiltres: currentPeriod?.filtres,
      questionLookup
    });

    const niveauSource = data.data[getNumberFiliereActif].niveau;
    const selectedTestNiveau = estimationTestSelection?.niveau || "";
    const selectedTestFiliere = estimationTestSelection?.filiere || "";
    const estimationFilieresOptions = selectedTestNiveau ? (ESTIMATION_TEST_OPTIONS[selectedTestNiveau] || []) : [];
    const niveauEstimation = questionInfo.idForm === "Estimation" && isEstimationTestWindowOpen && selectedTestNiveau
      ? selectedTestNiveau
      : niveauSource;
    const filiereEstimation = questionInfo.idForm === "Estimation" && isEstimationTestWindowOpen && selectedTestFiliere
      ? selectedTestFiliere
      : filiere;
    const questions = data.data[getNumberFiliereActif].criteres[getNumberCritereActif].sousCriteres[sousCritereIndex].questions;


    /* ------------------------------------------------------------ COMPORTEMENT ------------------------------------------------------------ */

    const isValidEmail = (email) => {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(email);
    };

    const validateBirthdateOver15 = (dateString) => {
      if (!dateString) return "";

      let day, month, year;

      // Cas 1 : format HTML5 type="date" → AAAA-MM-JJ
      if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
        [year, month, day] = dateString.split("-").map(Number);
      }
      // Cas 2 : format texte JJ/MM/AAAA
      else if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
        [day, month, year] = dateString.split("/").map(Number);
      } else {
        return "La date doit être au format AAAA-MM-JJ.";
      }

      // Vérification de la validité réelle de la date
      const d = new Date(year, month - 1, day);
      if (
        d.getFullYear() !== year ||
        d.getMonth() !== month - 1 ||
        d.getDate() !== day
      ) {
        return "La date saisie n'est pas valide.";
      }

      // Calcul de l'âge
      const today = new Date();
      let age = today.getFullYear() - year;
      const mNow = today.getMonth() + 1;
      const dNow = today.getDate();

      if (mNow < month || (mNow === month && dNow < day)) {
        age--;
      }

      if (age < 15) {
        return "Vous devez avoir au moins 15 ans.";
      } else if (age>64){
        return "La date saisie n'est pas valide.";
      }

      return ""; // pas d'erreur
    };

    const isValidIBAN = (ibanRaw) => {
      let iban = ibanRaw.replace(/\s+/g, '').toUpperCase();
      if (!/^[A-Z]{2}[0-9]{2}[A-Z0-9]{10,30}$/.test(iban)) {
        return false;
      }
      const rearranged = iban.slice(4) + iban.slice(0, 4);

      let numericIBAN = "";
      for (const char of rearranged) {
        if (char >= "A" && char <= "Z") {
          numericIBAN += (char.charCodeAt(0) - 55).toString();
        } else {
          numericIBAN += char;
        }
      }

      let remainder = "";
      for (let i = 0; i < numericIBAN.length; i += 7) {
        const block = remainder + numericIBAN.substring(i, i + 7);
        remainder = (parseInt(block, 10) % 97).toString();
      }

      return parseInt(remainder, 10) === 1;
    };

    const NIR_ID_FORM = "00NaT000001eMvh";
    const DOB_ID_FORM = "00NaT000001BMEL";
    const NIR_PLACEHOLDER = "999999999999999";

    const findQuestionByIdForm = (formId) => {
      if (!data || !data.data) return null;
      for (const period of data.data) {
        for (const critere of (period.criteres || [])) {
          for (const sousCritere of (critere.sousCriteres || [])) {
            for (const question of (sousCritere.questions || [])) {
              if (question.idForm === formId) {
                return question;
              }
            }
          }
        }
      }
      return null;
    };

    const parseBirthYearMonth = (dateString) => {
      if (!dateString) return null;
      let day;
      let month;
      let year;

      if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
        [year, month, day] = dateString.split("-").map(Number);
      } else if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
        [day, month, year] = dateString.split("/").map(Number);
      } else {
        return null;
      }

      if (!year || !month || month < 1 || month > 12) return null;
      return { year, month };
    };

    const getBirthNirMismatchMessage = () => {
      if (questionInfo.idForm !== NIR_ID_FORM && questionInfo.idForm !== DOB_ID_FORM) {
        return "";
      }

      const nirQuestion = findQuestionByIdForm(NIR_ID_FORM);
      const dobQuestion = findQuestionByIdForm(DOB_ID_FORM);

      if (!nirQuestion || !dobQuestion) return "";

      const nirValue = String(nirQuestion.value || "").replace(/\s/g, "");
      const dobValue = String(dobQuestion.value || "").trim();

      if (!nirValue || !dobValue) return "";
      if (nirValue === NIR_PLACEHOLDER) return "";
      if (!/^\d{15}$/.test(nirValue)) return "";

      const nirYear = parseInt(nirValue.slice(1, 3), 10);
      const nirMonth = parseInt(nirValue.slice(3, 5), 10);
      if (Number.isNaN(nirYear) || Number.isNaN(nirMonth)) return "";
      if (nirMonth < 1 || nirMonth > 12) return "";

      const birth = parseBirthYearMonth(dobValue);
      if (!birth) return "";

      const birthYearShort = birth.year % 100;
      if (birthYearShort !== nirYear || birth.month !== nirMonth) {
        return "La date de naissance ne correspond pas au numéro de sécurité sociale.";
      }

      return "";
    };



    const validateField = (placeholder, value) => {
      // Champ vide → ici je considère que c'est "valide structurellement"
      // (tu peux le passer à false si tu veux forcer un format même vide)
              console.log(placeholder)

      if (!value) {
        return { isValid: true, error: "" }
      }
      ;

      switch (placeholder) {
        case 10: { // email
          const ok = isValidEmail(value);
          return {
            isValid: ok,
            error: ok ? "" : "L'adresse e-mail n'est pas valide.",
          };
        }

        case 11: { // date + âge >= 15 ans
          const msg = validateBirthdateOver15(value); // ta fonction renvoie "" ou un message
          console.log("msg: " + msg);
          return {
            isValid: msg === "",
            error: msg,
          };
        }

        case 5: { // IBAN
          const compact = value.replace(/\s+/g, '').toUpperCase();
          if (!/^[A-Z]{2}[0-9]{2}[A-Z0-9]{10,30}$/.test(compact)) {
            return {
              isValid: false,
              error: "Format IBAN invalide (lettres et chiffres uniquement).",
            };
          }
          const ok = isValidIBAN(compact);
          return {
            isValid: ok,
            error: ok ? "" : "IBAN invalide (contrôle MOD 97 échoué).",
          };
        }

        case 6: { // BIC
          const compact = value.toUpperCase().replace(/\s+/g, "");
          if (!/^[A-Z0-9]{8}([A-Z0-9]{3})?$/.test(compact)) {
            return {
              isValid: false,
              error: "Le BIC doit contenir 8 ou 11 caractères alphanumériques.",
            };
          }
          if (!/^[A-Z]{4}/.test(compact)) {
            return {
              isValid: false,
              error: "Le BIC doit commencer par 4 lettres (code banque).",
            };
          }
          const country = compact.substring(4, 6);
          if (!/^[A-Z]{2}$/.test(country)) {
            return {
              isValid: false,
              error: "Le BIC doit contenir un code pays valide (2 lettres).",
            };
          }
          return { isValid: true, error: "" };
        }

        case 3: { // CVEC
          const compact = normalizeCVEC(value);
          if (compact.length !== 12) {
            return {
              isValid: false,
              error: "Le numéro CVEC doit contenir 12 caractères (3 lettres, 1 chiffre, 6 lettres, 2 chiffres).",
            };
          }
          const ok = /^[A-Z]{3}\d[A-Z]{6}\d{2}$/.test(compact);
          return {
            isValid: ok,
            error: ok ? "" : "Format CVEC invalide (AAA0AAAAAA00).",
          };
        }

        case 7: { // N° sécu
          // Ici tu mets ta logique de vérif du NIR.
          // Exemple ultra simplifié :
          const compact = normalizeNIR(value);
          let msg = "";
          if (!/^\d{15}$/.test(compact)) {
            msg = "Le numéro de sécurité sociale doit contenir 15 caractères.";
          }
          // + ta logique de clé modulo 97, etc. → si erreur, remplir msg
          return {
            isValid: msg === "",
            error: msg,
          };
        }

        case 4: { // INE
          const trimmed = normalizeINE(value);
          let msg = "";
          if (trimmed.length < 11 || trimmed.length > 12) {
            msg = "L'INE doit comporter 11 ou 12 caractères alphanumériques.";
          } else if (!/^[A-Z0-9]+$/.test(trimmed)) {
            msg = "L'INE ne doit contenir que des lettres et chiffres.";
          }
          return {
            isValid: msg === "",
            error: msg,
          };
        }

        default:
          return { isValid: true, error: "" };
      }
    };



    const handleChange = (event) => {
      let inputValue = event.target.value;
      if (data?.configuration === 'Echange') {
        const cleanedValue = normalizeExchangeValue(questionInfo, inputValue);
        const fieldError = exchangeFieldError(questionInfo, cleanedValue, 'en');
        setValue(cleanedValue);
        setError(fieldError);
        updateQuestionValue(sousCritereIndex, questionIndex, cleanedValue, !fieldError);
        return;
      }
      let name = event.target.name;

      let cleanedValue = inputValue;
      let newValue = value;

      // on nettoie l'erreur par défaut
      setError("");

      if (name === "00NaT000001fa29") {
        // Supprime tout ce qui n’est pas un chiffre
        newValue = value.replace(/' '/g, ''); // \D = tout sauf chiffre
        setValue(newValue);
        console.log("name")
      }



      if (questionInfo.idForm === NOMBRE_DE_PARTS_ID_FORM) {
        cleanedValue = normalizeNombreDeParts(inputValue);
      } else if (questionInfo.placeholder === 0) {



        // Autoriser lettres, accents, tirets, apostrophes, ^ et ¨
        cleanedValue = inputValue
          .toLowerCase()
          .replace(/[^a-zA-ZÀ-ÖØ-öø-ÿ' \-^¨]/g, '');

        if (cleanedValue.length > 0) {
          const firstChar = cleanedValue.charAt(0);
          if (firstChar === '-' || firstChar === "'") {
            cleanedValue = cleanedValue.slice(1);
          }

          // Majuscule au début
          cleanedValue =
            cleanedValue.charAt(0).toLocaleUpperCase('fr') + cleanedValue.slice(1);

          // Majuscule après tiret, apostrophe ou espace
          cleanedValue = cleanedValue.replace(
            /([-'\s])([a-zA-ZÀ-ÖØ-öø-ÿ])/g,
            (match, sep, char) => sep + char.toLocaleUpperCase('fr')
          );
        }
      } else if (questionInfo.placeholder === 1) {
        // Tout en majuscules
        cleanedValue = inputValue.replace(/[^a-zA-ZÀ-ÖØ-öø-ÿ' \-^¨]/g, '').toUpperCase();




      } else if (questionInfo.placeholder === 2) {



        // Format téléphone
        cleanedValue = inputValue.replace(/[^\d+]/g, '');

        if (cleanedValue.startsWith('0')) {
          cleanedValue = cleanedValue
            .replace(/^0(\d{9}).*/, '0$1')
            .replace(/(\d{2})(?=\d)/g, '$1 ')
            .trim();
        } else if (cleanedValue.startsWith('+')) {
          cleanedValue = '+' + cleanedValue.slice(1).replace(/\D/g, '');
        } else {
          cleanedValue = '';
        }



      } else if (questionInfo.placeholder === 3) {//CVEC



        // Normalisation pour éviter les soucis de copier-coller/espaces
        cleanedValue = normalizeCVEC(inputValue).slice(0, 12);
      } else if (questionInfo.placeholder === 4) { // INE
        cleanedValue = normalizeINE(inputValue).slice(0, 12);
      } else if (questionInfo.placeholder === 7) { // N° sécu
        cleanedValue = normalizeNIR(inputValue).slice(0, 15);
      }

      setValue(cleanedValue);

      // 2. Valider en fonction du placeholder (ou autre critère)
const exchangeDateMessage = data?.configuration === 'Echange' && questionInfo.type === 'date' ? exchangeDateError(cleanedValue) : null;
const { isValid, error } = exchangeDateMessage !== null ? { isValid: !exchangeDateMessage, error: exchangeDateMessage } : validateField(questionInfo.placeholder, cleanedValue);
setError(error);
      console.log("isValid: " + isValid)
      updateQuestionValue(sousCritereIndex, questionIndex, cleanedValue, isValid);

    };

    const handleEstimationTestNiveauChange = (event) => {
      if (!setEstimationTestSelection) return;
      const nextNiveau = event.target.value;
      const nextFilieres = nextNiveau ? (ESTIMATION_TEST_OPTIONS[nextNiveau] || []) : [];
      setEstimationTestSelection((previousSelection) => {
        const currentFiliere = previousSelection?.filiere || "";
        return {
          niveau: nextNiveau,
          filiere: nextFilieres.includes(currentFiliere) ? currentFiliere : ""
        };
      });
    };

    const handleEstimationTestFiliereChange = (event) => {
      if (!setEstimationTestSelection) return;
      const nextFiliere = event.target.value;
      setEstimationTestSelection((previousSelection) => ({
        ...previousSelection,
        filiere: nextFiliere
      }));
    };

    const resetEstimationTestSelection = () => {
      if (!setEstimationTestSelection) return;
      setEstimationTestSelection({ niveau: "", filiere: "" });
    };

    try {
        questions[questionIndex].visible = visible;
      } catch {

      }

      const crossFieldError = getBirthNirMismatchMessage();
      const displayError = error || (questionInfo.valideFormat === false
        ? (questionInfo.validationMessage || "Information Invalide")
        : "");
      const showCrossFieldError = Boolean(crossFieldError) && !displayError && questionInfo.valideFormat !== false;

      /* ------------------------------------------------------------ CALCUL POUR ESTIMATION COÛT DE SCOLARITÉ ------------------------------------------------------------ */


      useEffect(() => {
        if (questionInfo.idForm === "Estimation") {
            const RevenueFiscale = document.getElementById("00NaT000001fa29");
            const NombreDePart = document.getElementById("00NaT000001fa0X");
            const communicationFiscale = document.getElementById("00NaT000001fZyv");
            const RevenusEtranger = document.getElementById("00NaT000000Ky3F");

            const TabPartFixe = [ ["Simple L1", 3975],
                                  ["ESG L1", 3975],
                                  ["Double L1", 5925],
                                  ["SimpleSs L2", 3960],
                                  ["DoubleSs L2", 5910],
                                  ["SimpleAv L2", 4240],
                                  ["DoubleAv L2", 6190],
                                  ["ESG L2", 3960],
                                  ["Simple L3", 3950],
                                  ["Lpro L3", 3950],
                                  ["ESG L3", 3950],
                                  ["Double L3", 5890]];

            const TabPlafond = [  ["Simple L1", 8199],
                                  ["ESG L1", 8199],
                                  ["Double L1", 8855],
                                  ["SimpleSs L2", 8190],
                                  ["DoubleSs L2", 8850],
                                  ["SimpleAv L2", 8470],
                                  ["DoubleAv L2", 9130],
                                  ["ESG L2", 8190],
                                  ["Simple L3", 8180],
                                  ["Lpro L3", 8180],
                                  ["ESG L3", 8180],
                                  ["Double L3", 8840]];

            const TabTarifFix = [ ["Master T1", 4400],
                                  ["Master T2", 4400],
                                  ["Master T3", 5600],
                                  ["Master T4", 6200],
                                  ["Master T5", 7100],
                                  ["Master T6", 7200]];

            const TabPartFixeEtranger = [ ["ESG L1", 8300],
                                          ["ESG L2", 8300],
                                          ["ESG L3", 8300],
                                          ["Simple L1", 5950],
                                          ["Double L1", 7550],
                                          ["SimpleSs L2", 5700],
                                          ["DoubleSs L2", 6600],
                                          ["SimpleAv L2", 5700],
                                          ["DoubleAv L2", 6600],
                                          ["Simple L3", 5700],
                                          ["Lpro L3", 5700],
                                          ["Double L3", 6600]];

            let partFixeValue = 0;
            let plafondValue = 0;
            let tarifFixValue = 0;
            let partFixeEtrangerValue = 0;

            const coutType =
            niveauEstimation === "Licence 1"
              ? (filiereEstimation === "ANGLAIS (LLCER)" ? "Simple L1"
                : filiereEstimation === "DROIT" ? "Simple L1"
                : filiereEstimation === "ECONOMIE-GESTION" ? "Simple L1"
                : filiereEstimation === "ESPAGNOL (LLCER)" ? "Simple L1"
                : filiereEstimation === "HISTOIRE" ? "Simple L1"
                : filiereEstimation === "LETTRES" ? "Simple L1"
                : filiereEstimation === "MATHEMATIQUES" ? "Simple L1"
                : filiereEstimation === "PHYSIQUE" ? "Simple L1"
                : filiereEstimation === "PHYSIQUE-CHIMIE" ? "Simple L1"
                : filiereEstimation === "PHYSIQUE-CHIMIE-PARCOURS D’INGENIEUR ECAM RENNES" ? "Simple L1"
                : filiereEstimation === "SCIENCE POLITIQUE" ? "Simple L1"
                : filiereEstimation === "SCIENCE POLITIQUE - PARCOURS EUROPEAN SCHOOL OF GOVERNMENT (ESG)" ? "ESG L1"
                : filiereEstimation === "SCIENCES DE LA VIE" ? "Simple L1"
                : filiereEstimation === "SCIENCES POUR LA SANTE" ? "Simple L1"
                : filiereEstimation === "DOUBLE LICENCE DROIT- ECONOMIE ET GESTION" ? "Double L1"
                : filiereEstimation === "DOUBLE LICENCE DROIT-HISTOIRE" ? "Double L1"
                : filiereEstimation === "Double licence Droit-Lettres" ? "Double L1"
                : filiereEstimation === "DOUBLE LICENCE DROIT- SCIENCE POLITIQUE" ? "Double L1"
                : filiereEstimation === "DOUBLE LICENCE HISTOIRE-LETTRES" ? "Double L1"
                : filiereEstimation === "DOUBLE LICENCE HISTOIRE-SCIENCE POLITIQUE" ? "Double L1"
                : filiereEstimation === "DOUBLE LICENCE SCIENCE POLITIQUE-ANGLAIS" ? "Double L1"
                : filiereEstimation === "DOUBLE LICENCE SCIENCE POLITIQUE-ESPAGNOL" ? "Double L1"
                : filiereEstimation === "DOUBLE LICENCE SCIENCE POLITIQUE - LETTRES" ? "Double L1"
                : filiereEstimation === "DOUBLE CURSUS DROIT-PHILOSOPHIE" ? "DoubleCu L1"
                : filiereEstimation === "DOUBLE CURSUS MASTERS ET MANAGEMENT" ? "DoubleCu L1"
                : filiereEstimation === "DOUBLE CURSUS SCIENCE POLITIQUE-PHILOSOPHIE" ? "DoubleCu L1"
                : "Erreur")
              : niveauEstimation === "Licence 2"
              ? (filiereEstimation === "ANGLAIS (LLCER)" ? "SimpleAv L2"
                : filiereEstimation === "DROIT" ? "SimpleSs L2"
                : filiereEstimation === "ECONOMIE-GESTION" ? "SimpleSs L2"
                : filiereEstimation === "ESPAGNOL (LLCER)" ? "SimpleAv L2"
                : filiereEstimation === "HISTOIRE" ? "SimpleSs L2"
                : filiereEstimation === "LETTRES" ? "SimpleSs L2"
                : filiereEstimation === "MATHEMATIQUES" ? "SimpleSs L2"
                : filiereEstimation === "PHYSIQUE" ? "SimpleSs L2"
                : filiereEstimation === "PHYSIQUE-CHIMIE" ? "SimpleSs L2"
                : filiereEstimation === "PHYSIQUE-CHIMIE-PARCOURS D’INGENIEUR ECAM RENNES" ? "SimpleSs L2"
                : filiereEstimation === "SCIENCE POLITIQUE" ? "SimpleAv L2"
                : filiereEstimation === "SCIENCE POLITIQUE - PARCOURS EUROPEAN SCHOOL OF GOVERNMENT (ESG)" ? "ESG L2"
                : filiereEstimation === "SCIENCES DE LA VIE" ? "SimpleSs L2"
                : filiereEstimation === "SCIENCES POUR LA SANTE" ? "SimpleSs L2"
                : filiereEstimation === "DOUBLE LICENCE DROIT- ECONOMIE ET GESTION" ? "DoubleSs L2"
                : filiereEstimation === "DOUBLE LICENCE DROIT-HISTOIRE" ? "DoubleSs L2"
                : filiereEstimation === "Double licence Droit-Lettres" ? "DoubleSs L2"
                : filiereEstimation === "DOUBLE LICENCE DROIT- SCIENCE POLITIQUE" ? "DoubleSs L2"
                : filiereEstimation === "DOUBLE LICENCE HISTOIRE-LETTRES" ? "DoubleSs L2"
                : filiereEstimation === "DOUBLE LICENCE HISTOIRE-SCIENCE POLITIQUE" ? "DoubleSs L2"
                : filiereEstimation === "DOUBLE LICENCE SCIENCE POLITIQUE-ANGLAIS" ? "DoubleAv L2"
                : filiereEstimation === "DOUBLE LICENCE SCIENCE POLITIQUE-ESPAGNOL" ? "DoubleAv L2"
                : filiereEstimation === "DOUBLE LICENCE SCIENCE POLITIQUE - LETTRES" ? "DoubleSs L2"
                : filiereEstimation === "DOUBLE CURSUS DROIT-PHILOSOPHIE" ? "DoubleCu L2"
                : filiereEstimation === "DOUBLE CURSUS MASTERS ET MANAGEMENT" ? "DoubleCu L2"
                : filiereEstimation === "DOUBLE CURSUS SCIENCE POLITIQUE-PHILOSOPHIE" ? "DoubleCu L2"
                : "Erreur")
              : niveauEstimation === "Licence 3"
              ? (filiereEstimation === "ANGLAIS (LLCER)" ? "Simple L3"
                : filiereEstimation === "DROIT" ? "Simple L3"
                : filiereEstimation === "ECONOMIE-GESTION" ? "Simple L3"
                : filiereEstimation === "ESPAGNOL (LLCER)" ? "Simple L3"
                : filiereEstimation === "HISTOIRE" ? "Simple L3"
                : filiereEstimation === "LETTRES" ? "Simple L3"
                : filiereEstimation === "MATHEMATIQUES" ? "Simple L3"
                : filiereEstimation === "PHYSIQUE-CHIMIE" ? "Simple L3"
                : filiereEstimation === "PHYSIQUE-CHIMIE-PARCOURS D’INGENIEUR ECAM RENNES" ? "Simple L3"
                : filiereEstimation === "SCIENCE POLITIQUE" ? "Simple L3"
                : filiereEstimation === "SCIENCE POLITIQUE - PARCOURS EUROPEAN SCHOOL OF GOVERNMENT (ESG)" ? "ESG L3"
                : filiereEstimation === "SCIENCES DE LA VIE" ? "Simple L3"
                : filiereEstimation === "SCIENCES POUR LA SANTE" ? "Simple L3"
                : filiereEstimation === "DOUBLE LICENCE DROIT- ECONOMIE ET GESTION" ? "Double L3"
                : filiereEstimation === "DOUBLE LICENCE DROIT-HISTOIRE" ? "Double L3"
                : filiereEstimation === "Double licence Droit-Lettres" ? "Double L3"
                : filiereEstimation === "DOUBLE LICENCE DROIT- SCIENCE POLITIQUE" ? "Double L3"
                : filiereEstimation === "DOUBLE LICENCE HISTOIRE-LETTRES" ? "Double L3"
                : filiereEstimation === "DOUBLE LICENCE HISTOIRE-SCIENCE POLITIQUE" ? "Double L3"
                : filiereEstimation === "DOUBLE LICENCE SCIENCE POLITIQUE-ANGLAIS" ? "Double L3"
                : filiereEstimation === "DOUBLE LICENCE SCIENCE POLITIQUE-ESPAGNOL" ? "Double L3"
                : filiereEstimation === "DOUBLE LICENCE SCIENCE POLITIQUE - LETTRES" ? "Double L3"
                : filiereEstimation === "DOUBLE CURSUS DROIT-PHILOSOPHIE" ? "DoubleCu L3"
                : filiereEstimation === "DOUBLE CURSUS MASTERS ET MANAGEMENT" ? "DoubleCu L3"
                : filiereEstimation === "DOUBLE CURSUS SCIENCE POLITIQUE-PHILOSOPHIE" ? "DoubleCu L3"
                : filiereEstimation === "LICENCE PRO GUIDE-CONFÉRENCIER & MÉDIATEUR DES PATRIMOINES" ? "Simple L3"
                : filiereEstimation === "LICENCE PRO METIERS DU NOTARIAT" ? "Lpro L3"
                : filiereEstimation === "PRÉPA DCG" ? "DCG L3"
                : "Erreur")
              : (niveauEstimation === "Master 1" || niveauEstimation === "Master 2")
              ? (filiereEstimation === "HISTOIRE, CIVILISATIONS, PATRIMOINE" ? "Master T1"
                : filiereEstimation === "BIOLOGIE SANTÉ" ? "Master T3"
                : filiereEstimation === "BIOLOGIE SANTE" ? "Master T3"
                : filiereEstimation === "BIOLOGIE SANTE EVOLUTION DES PRATIQUES MEDICALES ET BIOETHIQUES" ? "Master T3"
                : filiereEstimation === "GESTION DES RESSOURCES HUMAINES" ? "Master T4"
                : filiereEstimation === "DROIT PUBLIC DES AFFAIRES" ? "Master T4"
                : filiereEstimation === "DROIT PUBLIC" ? "Master T4"
                : filiereEstimation === "POLITIQUES PUBLIQUES" ? "Master T4"
                : filiereEstimation === "RELATIONS INTERNATIONALES" ? "Master T4"
                : filiereEstimation === "RELATIONS INTERNATIONALES BRICS" ? "Master T4"
                : filiereEstimation === "MANAGEMENT ET COMMERCE INTERNATIONAL PARCOURS STRATÉGIE" ? "Master T5"
                : filiereEstimation === "MANAGEMENT ET COMMERCE INTERNATIONAL PARCOURS INTERNATIONAL" ? "Master T5"
                : filiereEstimation === "DROIT DES AFFAIRES" ? "Master T6"
                : filiereEstimation === "DROIT SOCIAL" ? "Master T6"
                : filiereEstimation === "DROIT FISCAL" ? "Master T6"
                : filiereEstimation === "DROIT NOTARIAL" ? "Master T6"
                : filiereEstimation === "HISTOIRE & DROIT DES RELATIONS ÉGLISE/ÉTAT" ? "Master EGLISE"
                : "Erreur")
              : "Autre Niveau";


            // Recherche de la valeur dans TabPartFixe
            const partFixeEntry = TabPartFixe.find(entry => entry[0] === coutType);
            if (partFixeEntry) {
                partFixeValue = partFixeEntry[1];
                //console.log("partFixeEntry")
                //console.log(partFixeEntry)

            }

            // Recherche de la valeur dans TabPlafond
            const plafondEntry = TabPlafond.find(entry => entry[0] === coutType);
            if (plafondEntry) {
                plafondValue = plafondEntry[1];
                //console.log("plafondValue")
                //console.log(plafondValue)
            }

            // Recherche de la valeur dans TabTarifFix
            const tarifFixEntry = TabTarifFix.find(entry => entry[0] === coutType);
            if (tarifFixEntry) {
              tarifFixValue = tarifFixEntry[1];
            }

            // Recherche de la valeur dans TabPlafond
            const partFixeEtrangerEntry = TabPartFixeEtranger.find(entry => entry[0] === coutType);
            if (partFixeEtrangerEntry) {
              partFixeEtrangerValue = partFixeEtrangerEntry[1];
            }

            const updateEstimationValue = (cl) => {
                const valueRevenu = RevenueFiscale ? parseFloat(RevenueFiscale.value) : NaN;
                const valueParts = NombreDePart ? parseFloat(NombreDePart.value) : NaN;
                const communicationFiscal = communicationFiscale ? communicationFiscale.value : NaN;
                let estimationValue = "-";
                let coef
                if (niveauEstimation === "Licence 1") {
                  coef=0.124;
                } else if (niveauEstimation === "Licence 2" || niveauEstimation === "Licence 3"){
                  coef=0.122;
                }
                // Assurez-vous que les valeurs sont des nombres pour éviter les erreurs de calcul
                if (niveauEstimation === "Licence 1" || niveauEstimation === "Licence 2" || niveauEstimation === "Licence 3") {
                  //console.log(cl)
                  console.log(communicationFiscal)
                  //console.log(communicationFiscal.value)
                  if(RevenusEtranger){
                    let valueRevenusEtranger = RevenusEtranger.value || "";
                    console.log("valueRevenusEtranger: "+valueRevenusEtranger);
                    if (valueRevenusEtranger === "Revenus domiciliés fiscalement à l'étranger") {
                      estimationValue=partFixeEtrangerValue;
                      console.log("étranger")
                    } else if (valueRevenusEtranger !== "" && communicationFiscal === "Non") {
                      console.log("true")
                      estimationValue=plafondValue;
                    } else if (communicationFiscal !== "" && !isNaN(valueRevenu) && !isNaN(valueParts) && valueParts !== 0) {
                        console.log(coutType) ;
                        estimationValue=(partFixeValue + ((valueRevenu / valueParts)*coef)).toFixed(2);
                          if (estimationValue>plafondValue){
                            estimationValue=plafondValue;
                          }
                    }
                  }
                } else if (niveauEstimation === "Master 1" || niveauEstimation === "Master 2"){
                  //console.log(tarifFixValue)
                  estimationValue=tarifFixValue;
                }
                  setValue(estimationValue + " €");
            };

            const handleRevenueInput = () => updateEstimationValue(1);
            const handlePartsInput = () => updateEstimationValue(2);
            const handleForeignIncomeInput = () => updateEstimationValue(3);
            const handleFiscalCommunicationInput = () => updateEstimationValue(4);

            // Attachez les écouteurs d'événements pour réagir aux changements de valeur
            RevenueFiscale && RevenueFiscale.addEventListener("input", handleRevenueInput);
            NombreDePart && NombreDePart.addEventListener("input", handlePartsInput);
            RevenusEtranger && RevenusEtranger.addEventListener("input", handleForeignIncomeInput);
            communicationFiscale && communicationFiscale.addEventListener("input", handleFiscalCommunicationInput);

            // Initialisez la valeur d'estimation au montage
            updateEstimationValue();
            //console.log(Niveau)

            if (niveauEstimation === "Master 1" || niveauEstimation === "Master 2"){
              setValue(tarifFixValue + " €");
            }

            // Nettoyez les écouteurs d'événements au démontage
            return () => {
                RevenueFiscale && RevenueFiscale.removeEventListener("input", handleRevenueInput);
                NombreDePart && NombreDePart.removeEventListener("input", handlePartsInput);
                RevenusEtranger && RevenusEtranger.removeEventListener("input", handleForeignIncomeInput);
                communicationFiscale && communicationFiscale.removeEventListener("input", handleFiscalCommunicationInput);
            };

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [questionInfo.idForm, updateQuestionValue, sousCritereIndex, questionIndex, questions, filiere, niveauEstimation, filiereEstimation]);

    /* ------------------------------------------------------------ AFFICHAGE ------------------------------------------------------------ */

    if (!visible) return null;

        return (
            <div className="question" id={"id:"+questionInfo.id} style={{display:"block"}}>
                    {questionInfo.idForm === "Estimation" && isEstimationTestWindowOpen ? (
                      <div style={{ marginBottom: "1rem", padding: "1rem", border: "1px solid #d9d9d9", borderRadius: "12px", backgroundColor: "#f8f6f1" }}>
                        <label className="questionTitle">Mode test estimation</label>
                        <p style={{ marginTop: "0.5rem" }}>
                          Ce choix est temporaire, disponible jusqu'au 31 mai 2026 et n'est pas enregistré dans le dossier étudiant.
                        </p>
                        <p style={{ marginTop: "0.5rem" }}>
                          Dossier actuel : {niveauSource} - {filiere}
                        </p>
                        <div style={{ display: "grid", gap: "0.75rem", marginTop: "0.75rem" }}>
                          <select value={selectedTestNiveau} onChange={handleEstimationTestNiveauChange}>
                            <option value="">Niveau réel du dossier</option>
                            {Object.keys(ESTIMATION_TEST_OPTIONS).map((niveauOption) => (
                              <option key={niveauOption} value={niveauOption}>{niveauOption}</option>
                            ))}
                          </select>

                          <select value={selectedTestFiliere} onChange={handleEstimationTestFiliereChange} disabled={!selectedTestNiveau}>
                            <option value="">Filière réelle du dossier</option>
                            {estimationFilieresOptions.map((filiereOption) => (
                              <option key={filiereOption} value={filiereOption}>{filiereOption}</option>
                            ))}
                          </select>

                          <button type="button" onClick={resetEstimationTestSelection}>
                            Réinitialiser le test
                          </button>
                        </div>
                      </div>
                    ) : null}

                    {/*Affiche l'étiquette de la question*/}
                    <label className="questionTitle">
                        {questionInfo.etiquette} :{questionInfo.required === "required" ? " *" : ""}
                    </label>
                    <div className="QuestionHelp" dangerouslySetInnerHTML={{ __html: questionInfo.QuestionHelp }} />
                    <div>
                    {/*Affiche l'input de la question*/}
                    <input
                      id={questionInfo.idForm}
                      name={questionInfo.idForm}
                      value={value}
                      onChange={handleChange}
  onPaste={(e) => {
    if (questionInfo.idForm === "00NaT000001fa29") {
      const pasted = e.clipboardData.getData('text');
      if (!/^\d+$/.test(pasted)) {
        e.preventDefault(); // bloque le collage s'il y a autre chose que des chiffres
      }
    }
  }}

  onKeyDown={(e) => {
  if ((questionInfo.placeholder === 3 || questionInfo.placeholder === 4 || questionInfo.placeholder === 7) && e.key === ' ') {
    e.preventDefault();
  }
  if (questionInfo.idForm === "00NaT000001fa29") {
    let lastKey = null;

    const allowedKeys = [
      'Backspace', 'Tab', 'Delete', 'ArrowLeft', 'ArrowRight', 'Home', 'End'
    ];
    const isDigit = e.key >= '0' && e.key <= '9';

    // Bloque tout sauf chiffres et touches autorisées
    if (!isDigit && !allowedKeys.includes(e.key)) {
      e.preventDefault();
    }

    // Bloque double espace
    if (e.key === ' ' && lastKey === ' ') {
      e.preventDefault();
    }

    lastKey = e.key;
  }
  }}
                      size="20"
                      type={data?.configuration === 'Echange' && questionInfo.type === 'date' ? 'text' : questionInfo.type}
                      lang={data?.configuration === 'Echange' ? 'en' : undefined}
                      placeholder={data?.configuration === 'Echange' && questionInfo.type === 'date' ? 'YYYY-MM-DD' : undefined}
                      className="text"
                      required={questionInfo.required}
                      readOnly={questionInfo.readonly || questionInfo.idForm === "Estimation"} // Marquer comme lecture seule si c'est "Estimation"
                      ref={inputRef}
                      />




                    {displayError && (
                      <div
                        className="field-error"
                        style={{ color: "red", fontSize: "0.9rem", marginTop: "4px" }}
                      >
                        {data?.configuration === 'Echange' ? (questionInfo.type === 'date' ? exchangeDateError(value) : exchangeError(displayError)) : displayError}
                      </div>
                    )}
                    {showCrossFieldError && (
                      <div
                        className="field-error"
                        style={{ color: "red", fontSize: "0.9rem", marginTop: "4px" }}
                      >
                        {data?.configuration === 'Echange' ? exchangeError(crossFieldError) : crossFieldError}
                      </div>
                    )}
                    {/* Refus du CRM lors de l'envoi : distinct des erreurs de
                        saisie ci-dessus, et non effacé par la frappe. */}
                    <SalesforceFieldError error={questionInfo.salesforceError} />
                    </div>

            </div>
        );

}/*q.value !== "" &&
                                        (q.valideFormat === undefined || q.valideFormat === true)*/
